export const queryString = (queryString) => ({
  type: 'QUERY_STRING',
  payload: queryString,
});



// WEBPACK FOOTER //
// ./src/actions/uri_actions.js